import Vue from 'vue'

const initialState = {
  list: [],
  employeeList: [],
  detail: {},
  loading: false,
  survey: {},
  results: {}
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    DELETE_SURVEY(state, id) {
      state.list = state.list.filter((survey) => survey.id !== id)
    },
    PUBLISH_SURVEY(state, id) {
      state.list = state.list.map((survey) => {
        if (survey.id === id)
          return {...survey, is_published: true}
        else return survey
      })
    }
  },
  actions: {
    getList({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`survey/surveys/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data.results})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    read({commit}, surveyId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`survey/surveys/${surveyId}/`).then(response => {
          commit('SET', {key: 'detail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    results({commit}, surveyId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`survey/surveys/${surveyId}/results/`).then(response => {
          commit('SET', {key: 'results', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    publish({commit}, surveyId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`survey/surveys/${surveyId}/publish/`).then(response => {
          commit('PUBLISH_SURVEY', surveyId)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    stop({commit}, surveyId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`survey/surveys/${surveyId}/stop/`).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, surveyId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.delete(`survey/surveys/${surveyId}/`).then(response => {
          commit('DELETE_SURVEY', surveyId)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    send({commit, state}, data) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`survey/surveys/${state.detail.id}/answers/`, data).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit, state}, survey) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`survey/surveys/`, survey).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit, state}, survey) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.put(`survey/surveys/${survey.id}/`, survey).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getEmployeeList({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/employees/search/?scope=all`).then(response => {
          commit('SET', {key: 'employeeList', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getForm({commit, state}, surveyId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`survey/surveys/${surveyId}/form_data/`).then(response => {
          commit('SET', {key: 'survey', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
